/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'GoalPanel.header.title': 'Цель',
  'goal-panel.generic-error.description': 'Проверьте подключение к Интернету и повторите попытку.',
  'goal-panel.generic-error.title': 'Произошла ошибка',
  'goal-panel.goal-panel-expand-field-button.show-less-collapsed-label': 'Показать больше полей',
  'goal-panel.goal-panel-expand-field-button.show-more-collapsed-label': 'Свернуть',
  'goal-panel.goal-panel-tabs.about-tab-title': 'Сведения',
  'goal-panel.goal-panel-tabs.jira-align-title': 'Jira Align',
  'goal-panel.goal-panel-tabs.jira-title': 'Jira',
  'goal-panel.goal-panel-tabs.projects-title': 'Проекты',
  'goal-panel.goal-panel-tabs.updates-tab-title': 'Обновления',
  'goal-panel.goal-title.edit-button-label': 'Изменить название цели',
  'goal-panel.goal-title.update-error-description': 'Не удалось обновить содержимое для проекта «{goalName}»',
  'goal-panel.goal-title.update-error-title': 'Произошла ошибка',
  'goal-panel.goal-title.validation-message': 'Укажите название цели',
};
